webpackJsonp(["conditioner38"],{

/***/ "./src/js/components/social-btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = socialBtn;
function socialBtn($container, _ref) {
  var url = _ref.url;

  var btnClick = function btnClick(e) {
    e.preventDefault();
    var left = window.screen.width / 2 - 600 / 2;
    var top = window.screen.height / 2 - 440 / 2;
    window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=600,height=440,top=' + top + ',left=' + left);
  };
  $container.addEventListener('click', btnClick);
  return function () {
    return $container.removeEventListener('click', btnClick);
  };
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner38.6f66b47685abffd9367d.js